import * as React from "react";

function IconLogin(props) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 26 26"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g
                fill="currentColor"
                fillRule="evenodd"
                stroke="currentColor"
                strokeWidth={0.5}
            >
                <path d="M13.486 12.98h-.972c-5.252.007-9.508 4.056-9.514 9.053v.566c.002 1.325 1.13 2.4 2.524 2.401h14.952c1.393-.001 2.522-1.076 2.524-2.401v-.566c-.006-4.997-4.262-9.046-9.514-9.052Zm8.461 9.619c0 .772-.659 1.398-1.47 1.4H5.523c-.812-.002-1.47-.628-1.471-1.4v-.566c.005-4.444 3.79-8.046 8.46-8.05h.973c4.671.004 8.456 3.606 8.461 8.05v.566ZM13 12.018c3.197 0 5.79-2.467 5.79-5.51C18.79 3.467 16.196 1 13 1S7.21 3.466 7.21 6.509c.004 3.04 2.594 5.505 5.79 5.509Zm0-10.016c2.616 0 4.737 2.018 4.737 4.507 0 2.49-2.12 4.507-4.737 4.507-2.616 0-4.737-2.018-4.737-4.507C8.266 4.02 10.385 2.004 13 2.002Z" />
            </g>
        </svg>
    );
}

export default IconLogin;
